
export class Controller {

    /** @ngInject */
    constructor($state, Alert, RemoteAppAccessService) {
        this.$state = $state;
        this.Alert = Alert;
        this.RemoteAppAccessService = RemoteAppAccessService;
    }

    $onInit() {
    	this.model =  this.remoteApp;
    	
    }

    save() {
        this.isSaving = true;
        this.model.groups=this.groupsModel.filter((group) => group.isSelected);
        this.RemoteAppAccessService
            .save(this.companyId, this.appId, this.model)
            .then((newRemoteAppsList) =>
            	Object.assign(this.remoteApps, newRemoteAppsList))
            .then(() => this.$state.go('^'))
            .then(() => this.Alert('success', 'company.manage-application.remote-appaccess.edit.edited'))
            .finally(() => this.isSaving = false)
    }

    saveDisabled(form) {
        return form.$invalid || this.isSaving ;
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/remote-app-access/edit/edit-remote-app.controller.js